import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate } from 'ui-seeker/utils'

import { SelectLoading } from "app/components/loading"
import { COMPETITION_URL } from 'app/@common/constants'


export default function SelectNights({ section, ...props }) {

	const customStyles = {
		option: (provided, state) => {
			return {
				...provided,
				backgroundColor: state.data.na ? '#f7f7fa' : '',
				color: state.data.na ? 'gray' : ''
			}
		}
	}
    const mergedStyles = {
        ...customStyles,
        menuPortal: (base) => ({ ...base, zIndex: 2000 }),
    };

	if ((section === 'competition' || section === 'parity' || section === 'packages') && (!props.sites || !props.date)) return <SelectLoading />
	if (section === 'packages' && Array.isArray(props.selectedRoute) && !!props.selectedRoute) return <SelectLoading />
	if (section === 'notifications' && (!props.alertType || !props.date)) return <SelectLoading />

	const myProps = {
		urlAjax: COMPETITION_URL.NIGHTS,
		placeholder: i18n.t('common:filters.filterNights'),
		icon: { icon: 'moon-stars' },
		extraParams: {
			id_site: props.sites,
			pax: props.occupancy || '',
			id_device: props.devices || '',
			dateRange: props.date,
			...props.sitePackageID?.length ? { sitePackageID: props.sitePackageID } : { id_site: props.sites },
			...props.refresh && { refresh_cache: props.refresh },
			...props.alertType && { tp: props.alertType },
			...props.selectedRoute?.length && { routes: props.selectedRoute },
			...props.id_report_execution && { id_report_execution: props.id_report_execution },
			...'id_main_hotel' in props && { id_main_hotel: props.id_main_hotel },
			...props.date === 'custom' && {
				startDate: formatDate(props.customDates[0], { format: FORMAT_DATE_BACK }),
				endDate: formatDate(props.customDates[1], { format: FORMAT_DATE_BACK })
			}
		},
		styles: mergedStyles,
		...props
	}

	return <SelectAjaxSeeker {...myProps} />
}